"use strict";
import { useState, useEffect } from "react";
function useMedia(query, initialState = false) {
  const [isMatch, setMatch] = useState(initialState);
  useEffect(() => {
    const mqList = window.matchMedia(query);
    setMatch(mqList.matches);
    const onChange = () => {
      setMatch(mqList.matches);
    };
    mqList.addListener(onChange);
    return () => {
      mqList.removeListener(onChange);
    };
  }, [query]);
  return isMatch;
}
export {
  useMedia
};
